// Home grid of featured streams (featured-only; no general browse).
import { useTranslation } from "react-i18next";
import { useFeatured } from "../api/hooks.js";
import { StreamGrid } from "./StreamGrid.js";

export function FeaturedGrid() {
  const { t } = useTranslation();
  const q = useFeatured();
  return (
    <StreamGrid
      items={q.data?.items ?? []}
      isLoading={q.isLoading}
      isError={q.isError}
      emptyTitle={t("home.emptyTitle")}
      emptyHint={t("home.emptyHint")}
    />
  );
}
